import { makeStyles } from 'tss-react/mui';

interface IProps {
  backgroundColor: string;
  color: string;
}

const useStyles = makeStyles<IProps>()((theme, { backgroundColor, color }) => ({
  alert: {
    color,
    backgroundColor,
    display: 'flex',
    padding: 4,
    borderRadius: 4,
    marginBottom: 5,
    marginTop: 5,
    '& svg': {
      height: 20,
      width: 20,
    },
    '& > p': {
      color,
      fontSize: 12,
      margin: 0,
      marginLeft: 7,
    },
  },
  alertTooltip: {
    fontSize: 15,
    fontWeight: 200,
    lineHeight: '20px',
  },
}));

export default useStyles;
